export default __webpack_public_path__ + "static/media/F&B-Banner.263a197b.jpg";